
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { ClassFormData } from "./types";

export const useClassMutation = (refetchClasses: () => Promise<any>) => {
  const { toast } = useToast();

  const checkUserSession = async () => {
    const { data: { user }, error } = await supabase.auth.getUser();
    if (error || !user) {
      throw new Error("No hay usuario autenticado");
    }
    
    // Verificar si el email está confirmado
    if (user.email_confirmed_at === null) {
      throw new Error("EMAIL_PENDING_CONFIRMATION");
    }
    
    return user;
  };

  const handleSubmit = async (formData: ClassFormData, editingId: string | null) => {
    try {
      console.log("🔧 useClassMutation.handleSubmit called");
      console.log("  - formData:", formData);
      console.log("  - editingId:", editingId);
      
      // Verificar el estado de la sesión antes de proceder
      await checkUserSession();
      
      if (editingId) {
        console.log("🔄 Updating existing class with ID:", editingId);
        const updateData = {
          title: formData.title,
          description: formData.description,
          instructor: formData.instructor,
          schedule: formData.schedule,
          capacity: formData.capacity,
          duration: formData.duration,
          updated_at: new Date().toISOString()
        };
        
        console.log("  - Update data:", updateData);
        
        const { error } = await supabase
          .from("classes")
          .update(updateData)
          .eq("id", editingId);

        if (error) {
          console.error("❌ Error updating class:", error);
          throw error;
        }
        
        console.log("✅ Class updated successfully");
        
        toast({ 
          title: "Clase actualizada",
          description: "La clase ha sido actualizada correctamente.",
          variant: "success"
        });
      } else {
        console.log("🆕 Creating new class");
        const user = await checkUserSession();
        const { error } = await supabase
          .from("classes")
          .insert([{
            title: formData.title,
            description: formData.description,
            instructor: formData.instructor,
            schedule: formData.schedule,
            capacity: formData.capacity,
            duration: formData.duration,
            gym_id: formData.gym_id,
            created_by: user.id,
          }]);

        if (error) {
          console.error("❌ Error creating class:", error);
          throw error;
        }

        toast({ 
          title: "Clase creada",
          description: "La clase ha sido creada correctamente.",
          variant: "success"
        });
      }

      await refetchClasses();
      console.log("✅ Classes refetched");
      return true;
    } catch (error: any) {
      console.error("Error managing class:", error);
      
      if (error.message === "EMAIL_PENDING_CONFIRMATION") {
        toast({
          variant: "destructive",
          title: "Email pendiente de confirmación",
          description: "Debes confirmar tu nueva dirección de email antes de poder realizar cambios. Revisa tu bandeja de entrada.",
        });
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: error.message || "No se pudo guardar la clase",
        });
      }
      return false;
    }
  };

  return { handleSubmit };
};
